import { Calendars } from '@benzinga/calendars/definitions';
import type { CalendarType } from '@benzinga/calendars';

export interface CalendarLink {
  slug: string;
  label: string;
  href: string;
}

const CALENDARS_WITH_OWN_ROUTE: Record<string, string> = {
  earnings: '/earnings',
  dividends: '/dividends',
  fda: '/fda-calendar',
  'analyst-ratings': '/analyst-stock-ratings',
};

const SIDEBAR_LABELS: Record<string, string> = {
  earnings: 'Earnings Calendar',
  dividends: 'Dividends Calendar',
  'conference-calls': 'Conference Calls Calendar',
  ipos: 'IPO Calendar',
  fda: 'FDA Calendar',
  economic: 'Economics Calendar',
  'stock-splits': 'Splits Calendar',
  'm-a': 'M&A Calendar',
  'analyst-ratings': 'Analyst Ratings',
  guidance: 'Guidance',
  spac: 'SPAC Calendar',
  'unusual-options-activity': 'Unusual Options Activity',
};

export const SIDEBAR_ORDER: CalendarType[] = [
  'earnings',
  'dividends',
  'conference-calls',
  'ipos',
  'fda',
  'economic',
  'stock-splits',
  'm-a',
  'analyst-ratings',
  'guidance',
  'spac',
  'unusual-options-activity',
];

export function calendarHref(slug: string): string {
  if (CALENDARS_WITH_OWN_ROUTE[slug]) return CALENDARS_WITH_OWN_ROUTE[slug];
  const canonical = Calendars[slug as keyof typeof Calendars]?.seo?.canonical;
  if (canonical) {
    try {
      return new URL(canonical).pathname;
    } catch {
      // fall through
    }
  }
  return `/calendars/${slug}`;
}

export const SIDEBAR_LINKS: CalendarLink[] = SIDEBAR_ORDER.map(slug => ({
  slug,
  label: SIDEBAR_LABELS[slug] ?? Calendars[slug as keyof typeof Calendars]?.name ?? slug,
  href: calendarHref(slug),
}));

export const EVENT_TYPE_LABELS: Record<string, string> = {
  earnings: 'Earnings',
  dividends: 'Dividends',
  'conference-calls': 'Conference Call',
  ipos: 'IPO',
  fda: 'FDA',
  'stock-splits': 'Stock Split',
  'm-a': 'M&A',
  'analyst-ratings': 'Analyst Rating',
  guidance: 'Guidance',
  spac: 'SPAC',
  'unusual-options-activity': 'Unusual Options',
};

